import { ScaleMode } from '../Enums';

export default class TextPlayer {
    constructor(testElement, sessionService, uiService) {
        this.signal = null;
        this.testElement = testElement;
        this.startLoading = [];
        this.endLoading = [];
        this.isStarted = false;
        this.isSkipped = false;
        this.displayTimeout = null;
        this.position = null;
        this.updateTimerTimeout = null;
        this.stateChangedCallback = null;
        this.isPreloaded = false;
        this.isActive = false;
        this.countDown = document.getElementById('textplayer-timer');
        this.isPreloaded = true;
        this.uiService = uiService;
        this.sessionService = sessionService;
        this.startTime = null;
        this.selectedText = "";
    }

    start() {
        return new Promise((resolve) => {
            this.selectText();                        
            this.signal = resolve;
            this.stateChanged();
            this.isStarted = true;
            this.isSkipped = false;
            this.startTime = Date.now();
            this._show();
            this.sessionService.saveSessionData({
                metaData: [{
                    DefaultQuestionText: this.selectedText.textGroup,
                    QuestionText: this.selectedText.textGroupName,
                    QuestionExternalKey: this.selectedText.textGroup,
                    DefaultAnswerText: this.selectedText.id.toString(),
                    AnswerText: this.selectedText.text.substring(0, 50),
                    AnswerExternalKey: this.selectedText.id.toString()
                }]
            });

        this.timer = 0;
        if (this.updateTimerTimeout) {
            clearTimeout(this.updateTimerTimeout);
        }

        const updateTimer = () => {
            return setTimeout(() => {
                this.timer += 1000;
                this.countDown.style.width = ((this.timer / this.testElement.cutoffTime) * 100) + '%';

                if (this.timer < this.testElement.cutoffTime) {
                    this.updateTimerTimeout = updateTimer();
                } else {
                    clearTimeout(this.updateTimerTimeout);
                    this.onStop();
                }
            }, 1000);
        }; 

        this.updateTimerTimeout = updateTimer();
        this.stateChanged();
        });
    }

    selectText() {
        var text = JSON.parse(this.testElement.metaData)
        var sessionID = this.sessionService.sessionId;
        var textId = sessionID % text.length;
        this.selectedText = text[textId];
    }

    getPosition() {
        if (!this.startTime) {
            return null;
        }

        const res = {};
        res.elementId = this.testElement.testElementSequenceID;        
        res.position = Date.now() - this.startTime;
        return res;
    }

    stateChanged() {
        if (this.stateChangedCallback) {
            try {
                this.stateChangedCallback(this.testElement);
            }
            catch (e) { }
        }
    }

    onStateChange(clbck) {
        if (clbck) {
            this.stateChangedCallback = clbck;
        }
    }

    onStop() {
        this.stateChanged(this.testElement);
        if (this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }

        if (this.updatePositionTimeout) {
            clearTimeout(this.updatePositionTimeout);
        }

        this.isActive = false;
        this._hide();
        this.isStarted = false;
        this.signal();
    }

    close() {
        if (this.isStarted) {
            this.onStop();
        }
    }

    _show() {
        const TextPlayerElement = document.getElementById('TextPlayer');
        if (!this.testElement || !TextPlayerElement) {
            return;
        }
        if (this.selectedText) {
            document.getElementById('textplayer-text').innerHTML = this.selectedText.text;
        }

        this.isActive = true;
        this.uiService.switchScreen('#TextPlayer');    
    }

    skip() {
        clearTimeout(this.displayTimeout);
        this.isSkipped = true;
        this.onStop();
    }

    _hide() {
        const TextPlayerElement = document.getElementById('TextPlayer');
         if (this.cutoffTimer) {
            this.cutoffTimer.innerText = '';
        }

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }
}